import { lazy, Suspense } from 'react';
import { MessageScope } from '../i18n';
import type { HandoffSheetProps } from './HandoffSheet';

const HandoffSheet = lazy(() => import('./HandoffSheet').then((m) => ({ default: m.HandoffSheet })));

/**
 * The hand-off sheet as its own chunk with its own messages (`handoff.*`, src/pages/namespaces.ts):
 * the top bar's button is on every page but the sheet is opened on few visits, so neither its code
 * nor its catalog is part of the shell (planning-app.md §4.5, `v2.10`). Nothing is painted until
 * both are in — the sheet appears a moment after the tap rather than empty.
 */
export function LazyHandoffSheet(props: HandoffSheetProps) {
  return (
    <Suspense fallback={null}>
      <MessageScope ns="handoff">
        <HandoffSheet {...props} />
      </MessageScope>
    </Suspense>
  );
}
